import { TypeDefinition } from "../generic";

export class MemberTypes {
    public static RegularMember: TypeDefinition = { id: 1, name: "RegularMember" };
    public static InternationalMember: TypeDefinition = { id: 2, name: "InternationalMember" };
    public static FellowInTrainingMember: TypeDefinition = { id: 3, name: "FellowInTrainingMember" };
    public static InternationalFellowMember: TypeDefinition = { id: 4, name: "InternationalFellowMember" };
    public static SeniorMember: TypeDefinition = { id: 5, name: "SeniorMember" };
    public static HonoraryMember: TypeDefinition = { id: 6, name: "HonoraryMember" };
    public static AssociateMember: TypeDefinition = { id: 7, name: "AssociateMember" };
    public static DeprecatedCoAuthor: TypeDefinition = { id: 8, name: "DeprecatedCoAuthor" };
    public static DeprecatedNonMemberAMRegistrant: TypeDefinition = { id: 9, name: "DeprecatedNonMemberAMRegistrant" };
    public static GenericApplicant: TypeDefinition = { id: 10, name: "GenericApplicant" };
    public static Staff: TypeDefinition = { id: 11, name: "Staff" };
    public static DeprecatedNonMemberAbstractAuthor: TypeDefinition = { id: 12, name: "DeprecatedNonMemberAbstractAuthor" };
    public static FITProvisional: TypeDefinition = { id: 13, name: "FITProvisional" };
    public static InternationalFITProvisional: TypeDefinition = { id: 14, name: "InternationalFITProvisional" };
    public static ImageBankMember: TypeDefinition = { id: 15, name: "ImageBankMember" };
    public static CorporateAffiliate: TypeDefinition = { id: 16, name: "CorporateAffiliate" };
    public static ScientificAssociate: TypeDefinition = { id: 17, name: "ScientificAssociate" };
    public static DeprecatedPATSurveyParticipant: TypeDefinition = { id: 18, name: "DeprecatedPATSurveyParticipant" };
    public static DeprecatedUnknown: TypeDefinition = { id: 19, name: "DeprecatedUnknown" };
    public static NonMember: TypeDefinition = { id: 20, name: "NonMember" };
    public static PracticeAdministrator: TypeDefinition = { id: 21, name: "PracticeAdministrator" };

    public static NonMemberValues: TypeDefinition[] = [
        MemberTypes.DeprecatedCoAuthor,
        MemberTypes.DeprecatedNonMemberAbstractAuthor,
        MemberTypes.DeprecatedNonMemberAMRegistrant,
        MemberTypes.DeprecatedPATSurveyParticipant,
        MemberTypes.DeprecatedUnknown,
        MemberTypes.GenericApplicant,
        MemberTypes.ImageBankMember,
        MemberTypes.NonMember,
    ];

    public static Values: TypeDefinition[] = [
        MemberTypes.RegularMember,
        MemberTypes.InternationalMember,
        MemberTypes.FellowInTrainingMember,
        MemberTypes.InternationalFellowMember,
        MemberTypes.SeniorMember,
        MemberTypes.HonoraryMember,
        MemberTypes.AssociateMember,
        MemberTypes.DeprecatedCoAuthor,
        MemberTypes.DeprecatedNonMemberAMRegistrant,
        MemberTypes.GenericApplicant,
        MemberTypes.Staff,
        MemberTypes.DeprecatedNonMemberAbstractAuthor,
        MemberTypes.FITProvisional,
        MemberTypes.InternationalFITProvisional,
        MemberTypes.ImageBankMember,
        MemberTypes.CorporateAffiliate,
        MemberTypes.ScientificAssociate,
        MemberTypes.DeprecatedPATSurveyParticipant,
        MemberTypes.DeprecatedUnknown,
        MemberTypes.NonMember,
        MemberTypes.PracticeAdministrator,
    ];

    public static isNonMember = (typeId: number) => {
        return MemberTypes.NonMemberValues.map((v) => v.id).indexOf(typeId) > -1;
    }
}



// WEBPACK FOOTER //
// ./src/models/member/MemberTypes.ts